// extracted by mini-css-extract-plugin
export default {"item":"FolderItem_item__t2Ud3","container":"FolderItem_container__yM2Ak"};